import { render, staticRenderFns } from "./AlipayRedPacket.vue?vue&type=template&id=51ec5df9&scoped=true"
import script from "./AlipayRedPacket.vue?vue&type=script&lang=js"
export * from "./AlipayRedPacket.vue?vue&type=script&lang=js"
import style0 from "./AlipayRedPacket.vue?vue&type=style&index=0&id=51ec5df9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec5df9",
  null
  
)

export default component.exports